import service from "@/store/services/init";

const state = {
  countries: {},
  disciplines: {},
  specializations: {},
  organizations: {},
  grades: {},
  stats: {},
};

const mutations = {
  SET_COUNTRIES: (state, countries) => {
    state.countries = countries;
  },
  SET_DISCIPLINES: (state, disciplines) => {
    state.disciplines = disciplines;
  },
  SET_SPECIALIZATIONS: (state, specializations) => {
    state.specializations = specializations;
  },
  SET_ORGANIZATIONS: (state, organizations) => {
    state.organizations = organizations;
  },
  SET_GRADES: (state, grades) => {
    state.grades = grades;
  },
  SET_STATS: (state, stats) => {
    state.stats = stats;
  },
};

const actions = {
  init({commit}, params) {  
    return service.init(params)
      .then((response) => {
        commit("SET_COUNTRIES", response.countries);
        commit("SET_DISCIPLINES", response.disciplines);
        commit("SET_SPECIALIZATIONS", response.specializations);
        commit("SET_ORGANIZATIONS", response.organizations);
        commit("SET_GRADES", response.grades);
        commit("SET_STATS", response.stats);
      });
  }
};

const getters = {
  countries: state => state.countries,
  disciplines: state => state.disciplines,
  specializations: state => state.specializations,
  organizations: state => state.organizations,
  grades: state => state.grades,
  engineerCount: state => state.stats.engineer_count,
  techCount: state => state.stats.tech_count,

};

const options = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default options;
